import { siteUrl } from '../site/metadata';
import { prefixLocale } from './prefix-locale';

export function buildAppDownloadWebUrl(locale?: string): string {
  return `${siteUrl}${prefixLocale('/app', locale)}`;
}
